import { graphql, useStaticQuery } from 'gatsby'
import HubspotBrochureDownload from '../HubspotBrochureDownload'

const Glossary = () => {
    const data = useStaticQuery(graphql`query glossaryQuery {
  allGhostPost(
    sort: {title: ASC}
    filter: {tags: {elemMatch: {name: {eq: "#glossary"}}}}
  ) {
    nodes {
      id
      title
      slug
      tags {
        name
        slug
      }
      feature_image
      excerpt
      url
      html
    }
  }
}`)
    const items = [];
    //console.log(data.allGhostPost.nodes)

    {data.allGhostPost.nodes.map((post, index) => {
        const url = `/corporate-wellness-glossary/${post.slug}/`
       // console.log(items)
       
        items.push(
            <article className=" col-sm-6 col-md-6 col-lg-4 item d-left glosaryListing" key={index}>
                <div className="shadowN box-shadow">
                    <div className="overflow">
                        <a href={ url } className="featured-image" title={ post.title }>
                        <img width="340" height="" className="img-responsive lozad" src={ post.feature_image } alt={ post.title} loading="lazy"/>
                        </a>
                    </div>
                    <div className="guideDetailsLink">
                        <p className="post_titel"><a href={ url } title={ post.title }> { post.title }</a></p>
                        <div className="blog_excerpt" >{ post.excerpt }</div>
                        <div className=" flw100"><a href={ url } title={ post.title } className = "links">Read More <span className="campaignSprite"></span></a></div>
                    </div>
                    
                </div>
            </article>)
    })}

    return (<>
      
        <section className="greyBackgroundN faqN NewsPage">
            <div className="container customCampaignContainer">
                <div className="row">
                    <div className="col-lg-12 col-md-12 col-xs-12 col-sm-12 ">
                      {items}
                    </div>
                </div>
            </div>
        </section>
        <section className="sectionSpacing featuresDetailsShape newsP">
            <div className="container customCampaignContainer">
                <div className="row">
                    <div className="col-lg-12 col-md-12 col-xs-12 col-sm-12 text-center">
                    <div className="colorwhite mainHeadingN">Stay updated with the latest trends</div>
                        <p className="colorwhite">Get our latest corporate wellness content right in your inbox.</p>
                        <div className = "newsForm"><HubspotBrochureDownload formID="1fab61f2-748b-4322-8a07-bd1ff6f1f18a"/></div> 
                    </div>
                </div>
            </div>
        </section>
        </>
    )
}

export default Glossary